<template>
  <div>
    <h1>Panel numbers</h1>
    <v-select
      label="Filter by branch"
      v-model="id"
      :items="branches"
      item-value="id"
      item-text="name"
      @change="update()"
      outline
    >
      <template slot="append-outer" v-if="id">
        <a @click="id = null;update();">
          <v-icon>clear</v-icon>
        </a>
      </template>
    </v-select>
    <v-btn @click="download">
      <v-icon>picture_as_pdf</v-icon>Download
    </v-btn>
    <v-card>
      <v-card-title v-if="computedPanelNumbers.length">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          outline
        />
      </v-card-title>
      <v-data-table
        :pagination.sync="pagination"
        :headers="headers"
        :items="computedPanelNumbers"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <router-link
                :to="{name:'group', params:{id:props.item.id}}"
                v-if="props.item.group"
              >{{props.item.name}}</router-link>
              <router-link
                :to="{name:'entity', params:{id:props.item.id}}"
                v-if="!props.item.group"
              >{{props.item.name}}</router-link>
            </td>
            <td>{{ props.item.group }}</td>
            <td>{{ props.item.panelNo }}</td>
            <td>
              <EntityZ :entity="props.item.branch" v-if="props.item.branch" />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "PanelNumbers",
  metaInfo() {
    return {
      title: "Panel numbers",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  computed: {
    computedPanelNumbers() {
      const value = this.computedG.concat(this.computedM);
      //group by panelno
      // return value.sort(this.sortTimestamp);
      return value;
    },
    computedG() {
      return this.computedGroupPanels.map(g => {
        return {
          id: g.groupid,
          name: g.group ? g.group.name : undefined,
          group: true,
          panelNo: g.panelno,
          branch: g.branch
        };
      });
    },
    computedM() {
      return this.computedMortgagePanels.map(m => {
        return {
          id: m.entityid,
          name: m.entity ? m.entity.name : undefined,
          group: false,
          panelNo: m.panelno,
          branch: m.branch
        };
      });
    },
    computedGroupPanels() {
      if (!this.groupPanels) {
        return [];
      }
      return this.groupPanels.map(g => {
        const group = this.groups ? this.groups[g.groupid] : undefined;
        const branch = this.computedBranches
          ? this.computedBranches[g.branchid]
          : undefined;
        return { ...g, group, branch };
      });
    },
    computedMortgagePanels() {
      if (!this.mortgagePanels) {
        return [];
      }
      return this.mortgagePanels.map(m => {
        const entity = this.entities ? this.entities[m.entityid] : undefined;
        const branch = this.computedBranches
          ? this.computedBranches[m.branchid]
          : undefined;
        return { ...m, entity, branch };
      });
    },
    computedBranches() {
      return this.branches
        ? convertListOfObjectsToMap(this.branches, "id")
        : undefined;
    }
  },
  data() {
    return {
      id: null,
      groupPanels: null,
      groups: null,
      mortgagePanels: null,
      entities: null,
      branches: null,
      headers: [
        {
          text: "Mortgage company",
          value: "name"
        },
        {
          text: "Group",
          value: "group"
        },
        {
          text: "Panel number",
          value: "panelNo"
        },
        {
          text: "Branches",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      },
      search: ""
    };
  },
  methods: {
    fetchGroupPanels() {
      nbmlaw
        .get(`/cors/admin/directory/groupPanels`, {
          params: { id: this.id }
        })
        .then(response => {
          // console.log(response.data);
          this.groupPanels = response.data;
        });
    },
    fetchGroups() {
      nbmlaw
        .get(`/cors/admin/directory/groupPanels/groups`, {
          params: { id: this.id }
        })
        .then(response => {
          // console.log(response.data);
          this.groups = response.data;
        });
    },
    fetchMortgagePanels() {
      nbmlaw
        .get(`/cors/admin/directory/mortgagePanels`, {
          params: { id: this.id }
        })
        .then(response => {
          // console.log(response.data);
          this.mortgagePanels = response.data;
        });
    },
    fetchEntities() {
      nbmlaw
        .get(`/cors/admin/directory/mortgagePanels/entities`, {
          params: { id: this.id }
        })
        .then(response => {
          // console.log(response.data);
          this.entities = response.data;
        });
    },
    fetchBranches() {
      nbmlaw
        .get(`/cors/admin/directory/branches`)
        .then(response => {
          // console.log(response.data);
          this.branches = response.data;
        })
        .catch(() => {});
    },
    download() {
      let url = `${process.env.VUE_APP_CT_URL}/cors/admin/directory/panelNumbers/download`;
      if (this.id) {
        url += `?id=${this.id}`;
      }
      window.open(url, "_blank");
    },
    update() {
      this.fetchGroupPanels();
      this.fetchGroups();
      this.fetchMortgagePanels();
      this.fetchEntities();
      this.fetchBranches();
    }
  },
  created() {
    this.update();
  }
};
</script>
